import { render, staticRenderFns } from "./metrics_class_header.vue?vue&type=template&id=c4d3632a&scoped=true&"
import script from "./metrics_class_header.vue?vue&type=script&lang=js&"
export * from "./metrics_class_header.vue?vue&type=script&lang=js&"
import style0 from "./metrics_class_header.vue?vue&type=style&index=0&id=c4d3632a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d3632a",
  null
  
)

export default component.exports